<template>
  <main id="wrapper" :class="{ 'menu-open': showMenu }">
    <MainHeader />
    <ViewTransitions />
  </main>
</template>

<script setup>
import { useStore } from './KQL.js'
import { routeStore } from '@/utils'
import { composables } from '@/composables'

const route = useRoute()
const routes = routeStore()
const { showMenu } = composables()
const kql = useStore()

setTimeout(() => kql.loadPageAndSite(route.path, route.name))
watch(route, (r) => kql.loadPage(r.path, r.name))
</script>

<style scoped>
main {
  min-height: 100vh;
  position: relative;
}
</style>
